export const SET_DEFAULT_APP = 'SET_DEFAULT_APP';

export const SET_DEFAULT_APP_WITH_CORE_EVENTS = 'SET_DEFAULT_APP_WITH_CORE_EVENTS';
